import { Span } from 'components/Typography';
import { ButtonBase } from './Button.style';
import { ButtonProps } from './Button.types';

const Button = ({
  p = '1rem 2.4rem',
  i18nKey,
  values,
  beforeComponent,
  afterComponent,
  children,
  typographyVariant = 'bold16',
  typographyExtraProps,
  tabIndex = 0,
  disabled,
  type = 'button',
  ...restOfProps
}: ButtonProps) => {
  return (
    <ButtonBase
      disabled={disabled}
      tabIndex={disabled ? -1 : tabIndex}
      p={p}
      type={type}
      {...restOfProps}
    >
      {beforeComponent}
      {children
        ? children
        : i18nKey && (
            <Span
              i18nKey={i18nKey}
              values={values}
              variant={typographyVariant}
              {...typographyExtraProps}
            />
          )}
      {afterComponent}
    </ButtonBase>
  );
};
export default Button;
